import { computed } from "vue";
import { AccessTypeRole } from "@xs2event/js-lib/api";
import { useUserStore } from "@/store/user";

const BRAND_SWITCHER_ROLES: string[] = [
  AccessTypeRole.Admin,
  AccessTypeRole.Operations,
  AccessTypeRole.ProductManagement,
  AccessTypeRole.Finance,
  AccessTypeRole.It,
];

export const hasBrandSwitcherRole = (roles: string[]) => roles.some((role) => BRAND_SWITCHER_ROLES.includes(role));

export function useCanSwitchBrand() {
  const userStore = useUserStore();
  return computed(() => hasBrandSwitcherRole(userStore.roles));
}
